export default __webpack_public_path__ + "static/media/img_about04.f0981f71.png";